module.exports = __webpack_public_path__ + "static/How-Acupuncture-Can-Enhance-Chiropractic-Care-Results-8f9c393263ab91b1dcbfb6eb576c0606.webp";